<emoji-mart
    [autoFocus]="true"
    [set]="config.iconSet"
    [emojiSize]="config.size"
    [sheetSize]="config.sheetSize"
    [imageUrlFn]="emojiUrlFn"
    [i18n]="locale"
    (emojiClick)="pickEmoji($event)"
></emoji-mart>
